import React from 'react'
import { useTranslation } from 'react-i18next'

import ConnectButton from '../connectButton'

const ConnectWithALiveAgent: React.FC = () => {
    const { t } = useTranslation()

    return <ConnectButton text={t('chat.liveAgent.agent.connectWithLV')} onClick={() => {}} testId="connect-with-a-live-agent" />
}

export default ConnectWithALiveAgent
